// Central site configuration — real data from Mamma Rosa Ipsos, Corfù
export const WHATSAPP_NUMBER = "306985906310"; // real WhatsApp number

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const CONTACT = {
  phones: [
    { display: "+39 335 410032", tel: "+39335410032" },
    { display: "+30 693 125 9598", tel: "+306931259598" },
  ],
  whatsappDisplay: "+30 698 590 6310",
  address: "Lungomare di Ipsos, Corfù 490 83, Grecia",
  addressShort: "Ypsos 490 83, Corfù",
  email: "info@mammarosacorfu.com",
  instagram: "https://www.instagram.com/mammarosa_corfu",
  facebook: "https://www.facebook.com/mammarosa.gr/",
  tiktok: "https://www.tiktok.com/@mammarosaypsoscorfu",
  mapEmbed:
    "https://www.google.com/maps?q=Mamma%20Rosa%20Ipsos%20Corfu&output=embed",
  mapLink: "https://www.google.com/maps/search/?api=1&query=Mamma+Rosa+Ipsos+Corfu",
  googleReviews: "https://www.google.com/maps/place/Mamma+Rosa+Ipsos+%E2%80%94+Ristorante+Pizzeria+Napoletana/data=!4m8!3m7!1s0x135b5b44407e9169:0xbdefa0af950ad8cb!8m2!3d39.6968808!4d19.8380291!9m1!1b1!16s%2Fg%2F11c5q_xb18",
  since: "2015",
  rating: "4,3",
  reviews: "844+",
};

export const IMAGES = {
  colazione: "/images/colazione.webp",
  heroPizza: "/images/hero-pizza.jpg",
  pizzaPrep: "/images/pizza-prep.jpg",
  corfuSea: "/images/corfu-sea.jpg",
  coastal: "/images/coastal.jpg",
  userPhotos: [
    "/images/terrazza-tramonto.jpg",
    "/images/user2.jpg",
    "/images/user3.jpg",
    "/images/user4.jpg",
    "/images/user5.jpg",
    "/images/user6.jpg",
    "/images/ape-lungomare.jpg",
  ],
};
